import 'dayjs/plugin/utc';

import { AppConfig, BillingType, DateTimeUtils } from '@bn/primitives';

/** From User data build trial conditions */
export const setupTrial: (data?: {
  BillingType?: BillingType;
  TrialBalance?: number;
  BillingFreeUntilDate?: string;
  TrialBandwidthLimit?: number;
  TotalBandwidthUsed?: number;
}) => UserTrial = (data) => {
  // Return some defaults, like if trial is not enabled
  if (!data)
    return {
      inProgress: false,
      balance: 0,
      bandwidthLeft: 0,
      ends: {
        days: 0,
        hours: 0,
        date: '',
      },
    };

  const now = DateTimeUtils.dayjsNow().utc();
  const trialEnd = DateTimeUtils.dayjs(data.BillingFreeUntilDate).utc();

  return <UserTrial>{
    inProgress: data.BillingType === 0,
    balance: data.TrialBalance ?? 0,
    bandwidthLeft: Math.max(0, (data.TrialBandwidthLimit || 0) - (data.TotalBandwidthUsed || 0)),
    ends: {
      days: Math.max(0, DateTimeUtils.getDurationBetweenDateTime(trialEnd, now, 'day', false)),
      hours: Math.max(0, Math.ceil(DateTimeUtils.getDurationBetweenDateTime(trialEnd, now, 'hour', false))),
      date: trialEnd.format(),
      isExpired: trialEnd < now,
    },
  };
};

/** From User data build trial conditions */
export const userDetailInterval: (intervals: AppConfig['api']) => {
  jwt: number;
  incompleteKyc: number;
} = (intervals) => {
  // Return some defaults, like if trial is not enabled
  if (!intervals)
    return {
      jwt: DateTimeUtils.getDurationAsMs(5, 'm'),
      incompleteKyc: DateTimeUtils.getDurationAsMs(30, 's'),
    };

  return {
    jwt: DateTimeUtils.getDurationAsMs(...intervals.refreshInterval.jwt),
    incompleteKyc: DateTimeUtils.getDurationAsMs(...intervals.refreshInterval.incompleteKyc),
  };
};

export type UserTrial = {
  balance: number;
  bandwidthLeft: number;
  // NOTE if less than 24h, days = 0
  ends: { days: number; hours: number; date: string; isExpired?: boolean };
  inProgress: boolean;
};
